import { render } from "./existingDetails.vue?vue&type=template&id=a558854c&scoped=true"
import script from "./existingDetails.vue?vue&type=script&lang=js"
export * from "./existingDetails.vue?vue&type=script&lang=js"

import "./existingDetails.vue?vue&type=style&index=0&id=a558854c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a558854c"]])

export default __exports__